export var slice = [].slice;



//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/d3-queue/src/array.js
// module id = ../../../../d3-queue/src/array.js
// module chunks = 3